import contactWidgetAvatar from '../../assets/avatars/sam_headshot.png';

export const CONTACT_WIDGET_NAME = 'Sam';
export const CONTACT_WIDGET_AVATAR_SRC = contactWidgetAvatar;
export const CONTACT_WIDGET_WHATSAPP_NUMBER = '447311799594';
export const CONTACT_WIDGET_WHATSAPP_PREFILL_TEXT = 'Hi, I have a question about Proposio.';
export const CONTACT_WIDGET_SUPPORT_EMAIL = 'support@proposio.ai';

export const buildWhatsAppUrl = (phoneNumber: string, prefillText: string) =>
  `https://wa.me/${phoneNumber}?text=${encodeURIComponent(prefillText)}`;
